import React from 'react';

export const DialogContext = React.createContext(null);

export default DialogContext;
